import React from "react";
import { Button, Grid } from "semantic-ui-react";
import { history } from "../../store";
import { blankHref } from "../../utils/utils";

type BackRowProps = {
  /** Return raw Semantic Button or full Grid with Row */
  rawButton: boolean;
  /** Button content */
  content: string;
  /** Display button icon */
  displayIcon: boolean;
};

class BackRow extends React.Component<BackRowProps> {
  static defaultProps: BackRowProps = {
    displayIcon: true,
    rawButton: false,
    content: "Back"
  };

  _goBack = () => {
    if (window.location.href.endsWith(blankHref)) return history.go(-2);
    history.goBack();
  };

  render() {
    const { content, displayIcon, rawButton } = this.props;
    if (rawButton) {
      return (
        <Button
          onClick={this._goBack}
          content={content}
          icon={displayIcon ? "arrow left" : null}
          labelPosition={displayIcon ? "left" : undefined}
        />
      );
    }
    return (
      <Grid textAlign="center" style={{ height: "100%", marginBottom: 0 }} verticalAlign="top">
        <Grid.Row
          columns={1}
          style={{
            maxWidth: 750,
            marginTop: "20px",
            marginBottom: 0,
            paddingBottom: 0
          }}
        >
          <Grid.Column width={16} textAlign="left">
            <Button
              onClick={this._goBack}
              content={content}
              icon="arrow left"
              labelPosition="left"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default BackRow;
